export interface IActiveMetrics {
    activeRequests: number;
    activeOutgoingRequests: number;
    pastDueOutgoingRequests: number;
    activeIncomingRequests: number;
    pastDueIncomingRequests: number;
}

export class ActiveMetrics implements IActiveMetrics {
    activeRequests: number;
    activeOutgoingRequests: number;
    pastDueOutgoingRequests: number;
    activeIncomingRequests: number;
    pastDueIncomingRequests: number;


    constructor() {
        this.activeRequests = 0;
        this.activeOutgoingRequests = 0;
        this.pastDueOutgoingRequests = 0;
        this.activeIncomingRequests = 0;
        this.pastDueIncomingRequests = 0;
    }
}